<script src="https://player.vimeo.com/api/player.js"></script>
<template>
  <div>
    <Navbar v-show="routemeta.navbar" />
    <Breadcrumb
      :breadcrumbOverride="breadcrumbOverride"
      v-show="routemeta.navbar"
    />
    <div class="container-xl">
      <div v-if="elearningstep" class="border-0 text-container-wider">
        <b-card-title>
          <h2 class="text-primary">
            {{ elearningstep ? elearningstep.step_name : '' }}
          </h2>
        </b-card-title>
        <b-card-body class="mx-0 px-0 col-12">
          <b-row class="mx-0 px-0">
            <div class="mx-0 px-0 col-xs-12 col-7">
              <span v-html="elearningstep ? elearningstep.step_introduction : ''"></span>
            </div>
            <div class="mx-0 px-0 col-xs-12 col-5 text-right text-top">
              <b-button
                :href="`/elearningmodule/${elearningstep ? elearningstep.module_id : 0 }`"
                class="mr-2"
              >
                Back
              </b-button>
              <b-button>Contact your tutor</b-button>
            </div>
          </b-row>
          <div v-if="elearningstep && elearningstep.step_videolink !== ''">
            <!-- <LearningVideo
              :vtoken="vtoken"
              :vid="vid"
              :elearningstep="elearningstep"
            /> -->
            <h3
              class="pt-4 mt-4"
              style="border-top: 1px solid black"
            >
              Video
            </h3>
            <div
              v-if="vid"
              style="padding:56.25% 0 0 0;position:relative;"
            >
              <iframe
                :src="`https://player.vimeo.com/video/${vid}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`"
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                style="position:absolute;top:0;left:0;width:100%;height:100%;"
                :title="`${elearningstep ? elearningstep.step_name : ''}`">
              </iframe>
            </div>
          </div>
          <div>
            <h3
              class="pt-4 mt-4"
              style="border-top: 1px solid black"
            >
              Notes
            </h3>
            <div class="row mx-1">
              <b-form-textarea
                v-model="step_note"
                placeholder="Enter your notes here"
                rows="3"
                class="col-12 mb-2"
              ></b-form-textarea>
            </div>
            <b-link
              class="ml-1"
              href=""
              @change="noteDirty = true"
              @click="stepnotes_save"
            >
              Save note
              <b-alert
                :show="dismissCountDown"
                dismissible
                @dismissed="dismissCountDown=0"
                @dismiss-count-down="countDownChanged"
                variant="success"
              >
                <span class="text-white">Note saved</span>
              </b-alert>
            </b-link>
          </div>
          <div class="accordion" v-if="elearningstep && elearningstep.step_description != ''" role="tablist">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-script variant="info">Script</b-button>
              </b-card-header>
              <b-collapse id="accordion-script" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <span v-html="elearningstep ? elearningstep.step_description : ''"></span>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
          <div
            class="row mx-1 pb-4 mb-4"
          >
            <div class="col-6 pl-0">
            <b-button
                v-if="step_number > 0"
                class="align-right"
                variant="secondary"
                @click.prevent="prevpage"
            >
                &lt; Back
            </b-button>
            </div>
            <div class="col-6 text-right pr-0">
            <b-button
                v-if="step_number < steps.length - 1"
                class="align-right"
                variant="primary"
                @click.prevent="nextpage"
            >
                Next &gt;
            </b-button>
            <b-button
                v-if="step_number >= steps.length - 1"
                class="align-right"
                variant="primary"
                @click.prevent="donemodule"
            >
                Done
            </b-button>
            </div>
          </div>
        </b-card-body>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import LearningVideo from './LearningVideo.vue';

export default {
    name: 'LearningStep',
    components: {
      Navbar,
      Breadcrumb,
      LearningVideo,
    },
    data() {
      return {
        routemeta: this.$route.meta,
        breadcrumbOverride: [],
        consultant_id: this.$store.state.user_id,
        step_id: this.$route.params.s ? this.$route.params.s : 0,
        steps: [],
        course_id: null,
        module_id: null,
        elearningcourse: null,
        elearningmodule: null,
        elearningstep: undefined,
        vtoken: null,
        vid: null,
        note_id: 0,
        step_note: '',
        noteDirty: false,
        savingNote: false,
        savedNote: false,
        dismissSecs: 2,
        dismissCountDown: 0
      }
    },
    created() {
      this.init();
    },
    computed: {
      step_number() {
        return this.steps.map(function(e) { return e.id; }).indexOf(this.elearningstep ? this.elearningstep.id : 1);
      }
    },
    watch: {
      '$route.path': function() { this.init(); },
      elearningstep: function() {}
    },
    methods: {
      init() {
        this.$store.dispatch('record_read', { table_name: 'g_elearning_steps', id: this.step_id })
        .then((resp) => {
          this.elearningstep = resp.data;
          this.module_id = resp.data.module_id;
          this.module_get();
          if (this.elearningstep.step_videolink) {
            this.vid = null;
            this.vid = this.elearningstep.step_videolink;
          } else {
            this.vid = null;
          }
          this.stepnotes_get();
          this.steps_get();
          this.$store.dispatch('elearningstep_update', { step_id: this.step_id });
        })
      },
      course_get() {
        this.$store.dispatch('record_read', { table_name: 'g_elearning_courses', id: this.course_id })
        .then((resp) => {
            this.elearningcourse = resp.data;
            this.breadcrumbOverride =  [
              { to: '/', text: 'My GDQ Management' },
              { to: '/learninghub', text: 'Learning Hub' },
              { to: `/elearningcourse/${this.elearningcourse.id}/0`, text: `${this.elearningcourse.course_name}` },
              { to: `/elearningmodule/${this.elearningmodule.id}`, text: `${this.elearningmodule.module_name}` },
              { to: '/', text: this.elearningstep.step_name }
            ];
        })
      },
      module_get() {
        this.$store.dispatch('record_read', { table_name: 'g_elearning_modules', id: this.module_id })
        .then((resp) => {
          this.elearningmodule = resp.data;
          this.course_id = resp.data.course_id;
          this.course_get();
          this.steps_get();
        })
      },
      stepnotes_get() {
        const filter = {
          consultant_id: {
            operator: '=',
            value: this.consultant_id,
          },
          step_id : {
            operator: '=',
            value: this.step_id,
          }
        }
        this.$store.dispatch('records_readall', { table_name: 'g_elearning_consultant_notes', filter})
        .then((resp) => {
          if (resp.data.total > "0") {
            const note = resp.data.result[0];
            this.note_id = note.id
            this.step_note = note.step_note;
          } else {
            this.note_id = 0;
            this.step_note = '';
          }
        })
      },
      stepnotes_save() {
        // eslint-disable-next-line
        this.savingNote = true;
        const dummy = this.step_note;
        const rec = {
          consultant_id: this.consultant_id,
          step_id: this.step_id,
          step_note: this.step_note,
        }
        if (this.note_id == 0) {
          this.$store.dispatch('record_post',{ table_name: 'g_elearning_consultant_notes', record: rec })
          .then(res => this.note_id = res.data.id );
          this.savedNote = true;
          this.noteDirty = false;
          this.savingNote = false;
          this.dismissCountDown = this.dismissSecs
        } else {
          this.$store.dispatch('record_put', { table_name: 'g_elearning_consultant_notes', id: this.note_id, record: rec });
          this.savedNote = true;
          this.noteDirty = false;
          this.savingNote = false;
          this.dismissCountDown = this.dismissSecs
        }
      },
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      steps_get() {
        const filter = {
          module_id: {
            operator: '=',
            value: this.module_id,
          }
        };
        this.$store.dispatch('record_readlist', { table_name: 'g_elearning_steps', filter, orderby: 'step_number'})
        .then((resp) => {
          this.steps = resp.data.result;
        })
      },
      prevpage() {
        let index = this.steps.map(function(e) { return e.id; }).indexOf(this.elearningstep.id);
        index--;
        if (index > -1) {
          this.$router.push({ path: '/elearningstep/'+this.steps[index].id })
          this.step_id = this.steps[index].id;
          this.init();
        }
      },
      nextpage() {
        let index = this.steps.map(function(e) { return e.id; }).indexOf(this.elearningstep.id);
        index++;
        if (index < this.steps.length) {
          this.$router.push({ path: '/elearningstep/'+this.steps[index].id })
          this.step_id = this.steps[index].id;
          this.init();
        }
      },
      donemodule() {
        const link = '/elearningcourse/'+this.course_id;
        this.$router.push({ path: link })
      },
      goback() {
        const link = '/elearningmodule/'+this.elearningstep.module_id;
        this.$router.push({ path: link })
      },
      gohome() {
        this.$router.push({ path: '/learninghub' })
      },
    }
}
</script>
<style scoped>

</style>
